export default {
  api: {
    host: 'https://ws.trimet.org',
    paths: {
      plan: '/rtp/gtfs/v1',
    },
  },
};
